// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                                           from 'firebase/functions';

// ===== Interfaces =====

import {
    IPostCollabDocReplaceResult,
}                                           from '../interfaces';

// ===== Enums =====

import {
    POST_COLLAB_DOC_CHECKPOINT_REASON,
}                                           from '../enums';

const replacePostCollaborativeDoc = async ({
    test,
    docId,
    value,
    checkpointReason,
}: {
    test: boolean,
    docId: string,
    value: string,
    checkpointReason?: POST_COLLAB_DOC_CHECKPOINT_REASON,
}): Promise<IPostCollabDocReplaceResult> => {
    const functions = getFunctions();
    const callable = httpsCallable<
        Record<string, boolean | string>,
        IPostCollabDocReplaceResult
    >(
        functions,
        'replacePostCollaborativeDoc',
    );
    const payload: Record<string, boolean | string> = {
        test,
        docId,
        value,
    };
    if (checkpointReason != null) {
        payload.checkpointReason = checkpointReason;
    }
    return callable(payload).then((result) => result.data as IPostCollabDocReplaceResult).catch((err) => {
        throw err;
    });
};

export default replacePostCollaborativeDoc;
